<script setup>
import { ref, onMounted, computed } from 'vue';
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
// import appConfig from "../../../app.config";
import axios from 'axios';
import { authHeader } from '../../helpers/authservice/auth-header';
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";


const title = ref('Delivery Report');

const items = ref([
  {
    text: "Home",
  },
    {
    text: "Reports",
  },
  {
    text: "Delivery Report",
    active: true,
  },
]);

const baseURL = computed(() => axios.defaults.baseURL);

const humanfriendlyConfig = ref({
  altInput: true,
  altFormat: "F j, Y",
  dateFormat: "Y-m-d"
});

const searchParams = ref({
  tracking_status_id: 'all',
  from: '',
  to: '',
});

const entries = ref({});

const getEntries = async () => {
  try {
    const response = await axios.get(`report/delivery/entries`, {
      headers: authHeader()
    })

    entries.value = response.data;

  } catch (err) {
    console.log(err);
  }
}
const clickSearch = () => {
  // console.log(searchParams.value);
}

onMounted(async () => {
  await getEntries();

})
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
        <div class="container-fluid">
          <div class="row">
              <div class="col-md-12 col-xl-3">
                <b-overlay :show="loading">
                    <div class="card">
                      <!-- <div class="card-header">
                        <h3>General Search</h3>
                      </div> -->
                      <div class="card-body">
                          <form @submit.prevent="clickSearch" action="">
                              <div class="mb-3 text-center">
                                <label for="search-status-*" class="form-label">User</label>
                                <select v-model="searchParams.tracking_status_id" class="form-select">
                                  <option value="all">All Tracking Status</option>
                                  <option  v-for="(entry, name) in entries" :value="entry.id" :key="name">{{ entry.name }}</option>
                                </select>
                              </div>
                              <div class="mb-3 text-center">
                                <label for="violation_date" class="form-label">Date of Upload</label>
                                <div class="d-flex">
                                  <flatPickr
                                    id="date"
                                    placeholder="From"
                                    v-model="searchParams.from"
                                    :config="humanfriendlyConfig"
                                    class="form-control flatpickr-input mr-1"
                                  ></flatPickr>
                                  <flatPickr
                                    id="date"
                                    placeholder="To"
                                    v-model="searchParams.to"
                                    :config="humanfriendlyConfig"
                                    class="form-control flatpickr-input ml-1"
                                  ></flatPickr>
                                </div>
                              </div>
                              <div class="text-center mt-5">
                                  <a :href="`${baseURL}/report/delivery?${Object.keys(searchParams).map(key => `${key}=${searchParams[key]}`).join('&')}`" download target="_blank" class="btn btn-info btn-sm float-right np-btn">
                                  <i class="tn btn-primary mdi mdi-microsoft-excel align-middle mr-1 fs-5 text-white"></i>
                                  Export Summary</a>
                              </div>
                          </form>
                      </div>
                    </div>
                </b-overlay>
              </div>
          </div>
        </div>
  </Layout>
</template>
